<template>
  <div
    class="pressContactCard"
    :class="{ 'pressContactCard--dark': theme === 'dark' }"
  >
    <!-- Default View -->
    <div v-if="!showContactDetails" class="pressContactCard__defaultView">
      <Heading
        :content="headline"
        tag="h2"
        class="pressContactCard__headline"
      />
      <p class="pressContactCard__text">{{ text }}</p>
      <div class="pressContactCard__buttons flex flex-col gap-4">
        <LinkButton
          buttonType="filled"
          :url="customerServiceUrl"
          target="_blank"
          rel="noopener noreferrer"
          fullWidth
          class="pressContactCard__button"
        >
          {{ customerServiceButtonLabel }}
        </LinkButton>
        <BasicButton
          buttonType="outlined"
          :theme="theme"
          :label="pressContactButtonLabel"
          :ariaLabel="pressContactButtonLabel"
          class="pressContactCard__button"
          fullWidth
          @buttonClick="onPressContactClick"
        />
      </div>
    </div>

    <!-- Contact Details View -->
    <div v-else class="pressContactCard__contactView">
      <BasicButton
        ref="backButtonRef"
        buttonType="text"
        :theme="theme"
        :stripped="true"
        class="pressContactCard__backButton"
        @buttonClick="onBackClick"
      >
        <SvgIcon name="arrowSimpleLeft" size="xxs" />
        Zurück
      </BasicButton>
      <Heading
        :content="contactHeadline"
        tag="h2"
        class="pressContactCard__contactHeadline"
      />
      <p class="pressContactCard__contactName">{{ contactName }}</p>
      <div class="pressContactCard__details">
        <p
          v-for="(detail, index) in contactDetails"
          :key="index"
          class="pressContactCard__detail"
        >
          <strong>{{ detail.label }}:</strong> {{ detail.value }}
        </p>
      </div>
      <LinkButton
        v-if="contactEmail"
        buttonType="text"
        :url="`mailto:${contactEmail}`"
        :stripped="true"
        class="pressContactCard__emailButton"
      >
        Email schreiben
        <template #icon>
          <SvgIcon name="arrowSimpleRight" size="xxs" />
        </template>
      </LinkButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import './PressContactCard.scss';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import BasicButton from 'ewi-ui/components/1-atoms/BasicButton';
import LinkButton from 'ewi-ui/components/1-atoms/LinkButton';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon';
import { ref } from 'vue';

defineOptions({
  name: 'PressContactCard',
});

export interface PressContactCardProps {
  headline?: string;
  text?: string;
  customerServiceButtonLabel?: string;
  pressContactButtonLabel?: string;
  theme?: 'light' | 'dark';
  customerServiceUrl?: string;
  contactHeadline?: string;
  contactName?: string;
  contactDetails?: Array<{ label: string; value: string }>;
  contactEmail?: string;
}

withDefaults(defineProps<PressContactCardProps>(), {
  headline: 'Pressekontakt',
  text: 'Bei nicht pressebezogenen Fragen ist unsere Kundenbetreuung für dich da.',
  customerServiceButtonLabel: 'Zur Kundenbetreuung',
  pressContactButtonLabel: 'Zum Pressekontakt',
  theme: 'dark',
  customerServiceUrl: '',
  contactHeadline: 'Pressekontakt',
  contactName: '',
  contactDetails: () => [],
  contactEmail: '',
});

const showContactDetails = ref(false);

const onPressContactClick = () => {
  showContactDetails.value = true;
};

const onBackClick = () => {
  showContactDetails.value = false;
};
</script>
